import type { VariantProps } from 'class-variance-authority';
import type { ElementType, HTMLAttributes, ReactNode, RefObject } from 'react';

import { cnva } from '@/app/utils/cnva';

export const ContainerStyled = cnva('w-full', {
  variants: {
    size: {
      sm: 'px-4 md:px-10',
      md: 'px-4 md:px-10 xl:px-13',
      'mobile-only': 'px-4 md:px-10 xl:px-0',
      'desktop-only': 'xl:px-13',
      none: '',
    },
    maxWidth: {
      sm: 'mx-auto max-w-160',
      md: 'mx-auto max-w-192',
      lg: 'mx-auto max-w-256',
      xl: 'mx-auto max-w-320',
      none: '',
    },
  },
  defaultVariants: {
    size: 'md',
    maxWidth: 'xl',
  },
});

export interface ContainerProps
  extends VariantProps<typeof ContainerStyled>, HTMLAttributes<HTMLDivElement> {
  ref?: RefObject<HTMLElement | null>;
  as?: ElementType;
  children: ReactNode;
  className?: string;
}

export const Container = ({
  ref,
  as: Component = 'div',
  children,
  className,
  size = 'md',
  maxWidth = 'xl',
  ...rest
}: ContainerProps) => {
  const CustomComponent = Component as any;
  return (
    <CustomComponent
      ref={ref}
      className={ContainerStyled({
        size,
        maxWidth,
        className,
      })}
      {...rest}
    >
      {children}
    </CustomComponent>
  );
};
